// @ts-nocheck
/* eslint-disable */
import Content from './content';

/**
 * @class Priorita plakatu na horni casti detailu
 * @private
 */
 export default class Poster extends Content {
	/**
	 * konstruktor
	 * @param  {string} data    - detail source
	 * @param  {object} options - optiony
	 */
	constructor(data, options) {
		super(data, options);

		this._priority = [
			"windyWebCam",
			"webcam",
			"photo",
			"video",
			"bestImage",
			"map",
			"pano",
			"placeholder"
		];
		this._contentsData = [];
	}

	/**
	 * Pridani contentu do posteru pro razeni priority
	 * @param {array} data - pole objektu s contentem a metodou
	 */
	addPosterData(data) {
		this._contentsData = data;

		this._getData();
	}

	/**
	 * vytvoreni contejneru
	 */
	_build() {
		this._dom.container.classList.add("content-poster");
	}

	/**
	 * Natazeni node z jednotlivych contentu ze kterych se rozhoduje, ktery ma prednost.
	 * Predpoklada se ze metoda pro nacitani node vrati promise.
	 */
	async _getData() {
		const promises = [];

		for (var i = 0; i < this._contentsData.length; i++) {
			if (this._contentsData[i].obj) {
				var content = this._contentsData[i];
				const prom = content.getData
					? content.obj[content.getData]()
					: content.obj.getPosterData();

				promises.push(prom);
			}
		}

		Promise.allSettled(promises).then(this._addNode.bind(this), this._addNode.bind(this));
	}

	/**
	 * Vraceni dat z contentu a jeho zpracovani. Rozhodovani, zda se dany node pouzije nebo zahodi
	 * @param {object} data - node daneho contentu
	 */
	_addNode(data) {
		let strongestDog = null;
		let strongestDogIndex = -1;

		for (let i = 0; i < data.length; i++) {
			if (data[i].status != "rejected" && (!strongestDog || this._priority.indexOf(data[i].value[1]) < this._priority.indexOf(strongestDog[1]))) {
				strongestDog = data[i].value;
				strongestDogIndex = i;
			}
		}

		if (strongestDog[1] == "pano") {
			const img = strongestDog[2].setPano();

			img.crossOrigin = "anonymous";
			img.addEventListener("load", e => {
				Mapy.Util.clear(this._dom.container);
				strongestDog[0].appendChild(img);
				this._dom.container.appendChild(strongestDog[0]);
			});
			// pokud se nepodari nacist obrazek panoramy, pano odstranime a zkusime najit jineho silaka
			img.addEventListener("error", () => {
				data.splice(strongestDogIndex, 1);
				this._addNode(data);
			});
		} else if (strongestDog[1] == "video") {
			Mapy.Util.clear(this._dom.container);
			this._dom.container.appendChild(strongestDog[0]);
			strongestDog[2].loadVideo().then(() => {}, () => {
				Mapy.Util.clear(this._dom.container);
				this._addNode(data.filter(item => item.value[1] !== "video"));
			});
		}
		else {
			Mapy.Util.clear(this._dom.container);
			this._dom.container.appendChild(strongestDog[0]);
		}

		const testEl = this._dom.container.querySelector("img");

		if (testEl) {
			testEl.crossOrigin = "anonymous";
		}
	}
}
